import { HeaderComponent } from "./HeaderComponent";

/**
 * Header экранов с кнопкой "Назад".
 */
export class BackHeader extends HeaderComponent {

    protected override build(): void {

        this.setLeft(

            this.createIconButton(

                "/img/back.png",

                "back",

                () => {
                    console.log("BACK BUTTON");
                    console.log(this.events);

                    this.events.backClicked?.();
                    console.log("AFTER CALL");

                }

            )

        );

        this.setCenter(

            this.createLogo()

        );

        this.setRight(

            this.createIconButton(

                "/img/User.png",

                "user",

                () => {

                    this.events.userClicked?.();

                }

            )

        );

    }

}